import { AbsenceHours, WeekWithHours, WeekWithHoursAndWaitingDayHours } from '../../../models'
import { getHoursPatchClearAndPostData } from '../../../redux/absences-ts/absencesHelpers'
import transformAbsenceHoursToPatchAbsenceHourData
    from '../../../services/AbsenceHoursService/transformAbsenceHoursToPatchAbsenceHourData'
import { FetchResult } from '../FetchResult'
import { NotificationCenterLog } from '../NotificationCenter/NotificationCenter'
import { deleteAbsenceHoursApiCall, patchAbsenceHoursApiCall, postAbsenceHoursApiCall } from './AbsenceHourService'

export const updateAbsenceHours = (
    absenceId: string,
    absenceHours: AbsenceHours[],
    eventLogTrackerData: NotificationCenterLog,
    weekdayWithHours: WeekWithHours[],
    waitingDayHours: number,
): (() => Promise<FetchResult<any, string>>)[] => {
    const data = getHoursPatchClearAndPostData(absenceHours, weekdayWithHours)
    const absenceHoursToPatch = data.toPatch as AbsenceHours[]
    const absenceHoursToClear = [...data.toClear, ...data.toDelete]
    const weekdays: WeekWithHoursAndWaitingDayHours[] = weekdayWithHours.map((weekday, index) => ({
        ...weekday,
        waitingDayHours: index === 0 ? (waitingDayHours || 0) : 0,
    }))

    return [
        () => patchAbsenceHoursApiCall(
            transformAbsenceHoursToPatchAbsenceHourData(absenceId, absenceHoursToPatch, weekdays),
            eventLogTrackerData,
        ),
        () => patchAbsenceHoursApiCall(
            absenceHoursToClear.map(absenceHourId => ({
                id: absenceHourId,
                absenceId,
                payrollPeriodId: undefined,
                hours: 0,
                weekNumber: undefined,
                waitingDayHours: 0,
            })),
            eventLogTrackerData,
        ),
        ...data.toDelete.map(absenceHourId => () => deleteAbsenceHoursApiCall(absenceHourId, eventLogTrackerData)),
        ...data.toPost.map((weekday) => () => postAbsenceHoursApiCall(
            absenceId,
            eventLogTrackerData,
            weekday.payrollPeriod?.id,
            weekday.hours,
            weekday.weekNumber,
            weekdays.find(w => w.weekNumber === weekday.weekNumber)?.waitingDayHours,
        )),
    ]
}
